<template>
    <Calendar v-model="theDate" :showTime="false" :selectOtherMonths="true" :locale="sv" dateFormat="yy-mm-dd" />
</template>
<script>
import { abstractField } from 'vue-form-generator'
import Calendar from 'primevue/calendar'
import { isNil } from 'lodash'
import moment from 'moment'
export default {
  beforeMount () {
    if (isNil(this.value)) {
      this.value = ''
    } else if (this.value === '') {
      this.value = ''
    } else {
      this.value = new Date(this.value)
    }
  },
  components: {
    Calendar,
    moment
  },
  data () {
    return {
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      }
    }
  },
  mixins: [abstractField],
  computed: {
    theDate: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.value = newValue
        return this.value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vfg-custom-fields/fieldDatePicker.vue